<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  mode: {
    type: String,
    default: 'create',
    validator: value => ['create', 'rename'].includes(value),
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['save']);

const { t } = useI18n();
const dialogRef = ref(null);
const name = ref('');

const title = computed(() =>
  props.mode === 'rename'
    ? t('AUTOMATION.FOLDERS.EDIT')
    : t('AUTOMATION.FOLDERS.ADD')
);

const open = (currentName = '') => {
  name.value = currentName;
  dialogRef.value?.open();
};

const close = () => {
  dialogRef.value?.close();
};

const onConfirm = () => {
  const trimmed = name.value.trim();
  if (!trimmed) return;
  emit('save', trimmed);
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="md"
    :title="title"
    :confirm-button-label="$t('AUTOMATION.FOLDERS.SAVE')"
    :cancel-button-label="$t('AUTOMATION.FOLDERS.CANCEL')"
    :disable-confirm-button="!name.trim()"
    :is-loading="isLoading"
    @confirm="onConfirm"
  >
    <div class="px-6 pt-4">
      <input
        v-model="name"
        type="text"
        class="w-full h-10 px-3 text-sm rounded-lg bg-n-alpha-black2 outline outline-1 outline-n-weak text-n-slate-12"
        :placeholder="$t('AUTOMATION.FOLDERS.NAME_PLACEHOLDER')"
      />
    </div>
  </Dialog>
</template>
